export default __webpack_public_path__ + "static/media/iusd2.895721eb.png";